import { CameraOff, Circle, MicOff, Pause, Phone, Star, UserPlus, Users, VideoOff, Volume2 } from "react-feather";

export const FontsData = ["primary", "success", "danger", "light", "warning"];

export const FontsAndBadgeData = [{ color: ["primary", "success", "danger", "light", "warning"] }, { color: ["outline-primary", "outline-success", "outline-danger", "outline-light", "outline-warning"] }];

export const BadgesData = [
  {
    class: "col-12",
    data: [
      { className: "badge-outline-primary", label: "label-primary" },
      { color: "success", className: "font-light", label: "label-success" },
    ],
  },
  {
    class: "col-md-6 col-sm-12",
    data: [
      { className: "badge-outline-primary xl", label: "label-primary" },
      { color: "success", className: "font-light xl", label: "label-success" },
    ],
  },
  {
    class: "col-md-6 col-sm-12",
    data: [
      { className: "badge-outline-primary xl rounded", label: "label-primary" },
      { color: "success", className: "font-light xl rounded", label: "label-success" },
    ],
  },
];

export const LabelBadgeData = [
  {
    class: "col-12",
    data: [
      { className: "badge-outline-primary xl", label: "label-primary", icon: <i className="ti-settings" /> },
      { className: "badge-outline-success xl", label: "label-success", icon: <i className="ti-settings" /> },
      { color: "primary", className: "xl", label: "label-primary", icon: <Star /> },
      { color: "success", className: "xl", label: "label-success", icon: <Star /> },
    ],
  },
  {
    class: "col-md-6 col-sm-12",
    data: [
      { className: "badge-outline-primary fonts", label: "label-primary", icon: <i className="ti-settings" /> },
      { className: "badge-outline-success fonts", label: "label-success", icon: <i className="ti-settings" /> },
      { color: "primary", className: "fonts", label: "label-primary", icon: <Star /> },
      { color: "success", className: "fonts", label: "label-success", icon: <Star /> },
    ],
  },
  {
    class: "col-md-6 col-sm-12",
    data: [
      { className: "badge-outline-primary sm fonts", label: "label-primary", icon: <i className="ti-settings" /> },
      { className: "badge-outline-success sm fonts", label: "label-success", icon: <i className="ti-settings" /> },
      { color: "primary", className: "sm fonts", label: "label-primary", icon: <Star /> },
      { color: "success", className: "sm fonts", label: "label-success", icon: <Star /> },
    ],
  },
];

export const ElementBadgeData = ["primary", "success", "danger", "warning", "info", "light", "dark"];

export const ButtonBackgroundData = ["primary", "success", "danger", "light", "warning", "outline-primary", "outline-success", "outline-danger", "outline-light", "outline-warning"];

export const IconTypes = [<Circle />, <Users />, <Star />, <Star />, <Star />];

export const ButtonVariants = ["btn-primary", "btn-success", "btn-danger", "btn-light", "btn-warning", "btn-outline-primary", "btn-outline-success", "btn-outline-danger", "btn-outline-light", "btn-outline-warning"];

export const ButtonSizes = ["btn-xl", "btn-xl rouded15", "btn-sm", "btn-xs"];

export const SidebarIconData = ["messege", "userbox", "notification"];

export const TemplateButtonsData = [
  [
    { className: "btn-primary btn-sm", icon: <Circle /> },
    { className: "btn-success btn-sm", icon: <Users /> },
  ],
  [
    { className: "btn-primary btn-sm", icon: <Circle /> },
    { className: "btn-success btn-sm", icon: <Users /> },
    { className: "btn-success btn-sm", icon: <Users /> },
  ],
  [
    { className: "btn-primary", icon: <Circle /> },
    { className: "btn-success", icon: <Users /> },
  ],
  [
    { className: "btn-primary", icon: <Circle /> },
    { className: "btn-primary", icon: <Circle /> },
    { className: "btn-success", icon: <Users /> },
  ],
];

export const Messages = [
  ["Hi Alan, Please send me document.", "Imigiatly."],
  ["Hi Alan, Please send me document.", "Imigiatly."],
  ["Hi Alan, Please send me document.", "Hi Alan, Please.", "Imigiatly."],
];

export const GalleryImages = [{ src: "gallery/6.jpg" }, { src: "gallery/7.jpg" }, { src: "gallery/8.jpg" }, { src: "gallery/9.jpg" }];

export const SharedDocumentData = [
  { icon: "folder font-danger", text: "Simple_practice_project-zip" },
  { icon: "write font-success", text: "Word_Map-jpg" },
  { icon: "zip font-primary", text: "Latest_Design_portfolio.pdf" },
];

export const MediaItemsData = [
  [{ src: "avtar/1.jpg", size: "big" }],
  [
    { src: "avtar/2.jpg", size: "small" },
    { src: "avtar/3.jpg", size: "small" },
  ],
  [
    { src: "avtar/big/audiocall.jpg", size: "small" },
    { src: "avtar/5.jpg", size: "small" },
  ],
];

export const ReceiveAudioCallData = [{ icon: <i className="fa fa-microphone" />, className: "mute" }, { icon: <i className="fa fa-volume-up" />, className: "mute" }, { icon: <Phone />, className: "is-animating", color: "danger" }, { icon: <UserPlus /> }, { icon: <Pause /> }];

export const ConferenceCallData = ["2", "3", "5", "big/videocall_bg"];

export const VideoCallConferenceData = ["big/videocall_bg", "5", "2", "3"];

export const FooterActions = [{ icon: <Volume2 /> }, { icon: <CameraOff /> }, { icon: <UserPlus /> }, { icon: <Phone />, className: "btn-danger is-animating btn-sm" }, { icon: <VideoOff />, tooltip: "Disable Video" }, { icon: <MicOff />, className: "mic btn-light"}, { icon: <Pause /> }];

export const DotButtonBadgeData = [
  { className: "badge-outline-primary", color: "primary", label: "label-primary" },
  { className: "badge-outline-success", color: "success", label: "label-success" },
  { className: "badge-outline-primary", color: "primary", label: "label-primary" },
  { className: "badge-outline-success", color: "success", label: "label-success" },
];